var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_3576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_3576",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2819 2H0V22H34.2819V2Z",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.141 6.99498C19.8996 6.99498 22.1426 9.23134 22.1426 11.9967C22.1426 14.7553 19.9063 16.9983 17.141 16.9983C14.3823 16.9983 12.1393 14.762 12.1393 11.9967C12.1393 9.23803 14.3823 6.99498 17.141 6.99498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1409 8.24707C19.2099 8.24707 20.8905 9.92769 20.8905 11.9967C20.8905 14.0656 19.2099 15.7462 17.1409 15.7462C15.072 15.7462 13.3914 14.0656 13.3914 11.9967C13.3914 9.92769 15.072 8.24707 17.1409 8.24707Z",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1386 8.99699C19.7924 8.99699 21.1383 10.3428 21.1383 11.9967C21.1383 13.6505 19.7924 14.9963 18.1386 14.9963C16.4848 14.9963 15.1389 13.6505 15.1389 11.9967C15.1389 10.3428 16.4848 8.99699 18.1386 8.99699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 11.9967L18.0315 12.693L18.3796 11.6217",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 11.9967L18.0315 11.3003L18.3796 12.3716",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4489 9.85403V12.1038H18.5671",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4489 9.85403L18.768 11.6753L17.8574 12.3381",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4489 14.1393L18.768 12.318L17.8574 11.6552",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4489 14.1393V11.8895H18.5671",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9598 10.6709L17.8239 11.3673L18.1654 12.4386",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9598 10.6709L18.6408 12.4921L17.7302 11.836",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9598 13.3224L18.6408 11.5012L17.7302 12.1574",
    fill: "#D30025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9598 13.3224L17.8239 12.626L18.1654 11.5547",
    fill: "#D30025"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_3576",
    x: 0,
    y: 0,
    width: 34,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_3576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_3576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunisia);
export default __webpack_public_path__ + "static/media/Tunisia.d95a8bcce7504e41fbbf0e79a48e835c.svg";
export { ForwardRef as ReactComponent };